// The start screen's honest head count: real connected players only. Nothing to say at 0.
export const onBlockLine = n => (Number.isInteger(n) && n > 0 ? `${n} ${n === 1 ? 'person' : 'people'} on the block now` : '');
